import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "dashboard-page" }
const _hoisted_2 = { class: "simple-page" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "simple-page__title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Дашборд")
], -1)
const _hoisted_4 = {
  class: "simple-page__content",
  style: {"height":"auto !important"}
}
const _hoisted_5 = {
  class: "f",
  style: {"gap":"1rem","flex-wrap":"wrap"}
}
const _hoisted_6 = { class: "content" }
const _hoisted_7 = {
  class: "f mt-10 mb-10",
  style: {"gap":"1rem","flex-wrap":"wrap"}
}
const _hoisted_8 = { class: "wrapper" }
const _hoisted_9 = {
  class: "simple-page__table mt-10",
  style: {"height":"none","position":"relative"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, "Последние ошибки", -1)

import { ref, computed, onMounted, watch } from "vue";
import {
  ArrowRightIcon,
  PlusIcon,
  Cog8ToothIcon,
  ClockIcon,
  PuzzlePieceIcon,
  ArrowPathIcon,
} from "tir-style-system/icons/outline";
import { ArrowLeftIcon } from "tir-style-system/icons/solid";
import { useRoute, useRouter } from "vue-router";
import {
  DatepickerTypeEnum,
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmDatepicker,
} from "tir-components";
import Plashka from "./components/plashka.vue";
import { ScheduleStatus } from "../_uc/schedule-status";
import EnumJobStatus from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/database/enums/EnumJobStatus";
import GanttChart from "./components/gantt-chart.vue";
import StatusChanges from "./components/status-changes.vue";
import JobStatusHistoryItem from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/i-services/models/jobs/histories/status/JobStatusHistoryItem";
import EnumJobContainerStatus from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/database/enums/EnumJobContainerStatus";
import StatusHistoryItem from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/i-services/models/jobs/histories/status/StatusHistoryItem";
import ContainerStatusHistoryItem from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/i-services/models/containers/ContainerStatusHistoryItem";
import TirPmTable from "tir-pm-table/src/TirPmTable.vue";
import TirPmTableTh from "tir-pm-table/src/TirPmTableTh.vue";
import TirPmTableTr from "tir-pm-table/src/TirPmTableTr.vue";
import DashboardParametersRequest from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/i-services/models/dashboard/DashboardParametersRequest";
import DashboardParametersResponse from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/i-services/models/dashboard/DashboardParametersResponse";
import AdapterDashboardService from "./adapter/AdapterDashboardService";
import DonutChart from "./components/DonutChart.vue";
import JobsTimelineRequest from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/i-services/models/dashboard/JobsTimelineRequest";
import JobsTimelineResponse from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/i-services/models/dashboard/JobsTimelineResponse";
import PageRequest from "@/api/SchedulerAdmin/dataSource/api/pagination-helper/lib/PageRequest";
import DashboardRow from "./components/dashboard-row.vue";
import Loading from "../_uc/Loading.vue";
// Определение пропсов компонента

export default /*#__PURE__*/_defineComponent({
  __name: 'dashboard-page',
  props: {
  isCompact: { type: Boolean, value: true },
  msg: { type: String, default: "" },
},
  emits: ["clickLogout", "update:message"],
  setup(__props, { emit: emits }) {

const props = __props;

// Импорты из Vue 3 Composition API


// Определение эмиттеров событий компонента

const resp = ref<DashboardParametersResponse>();
const req = ref<DashboardParametersRequest>();

const timeLineResp = ref<JobsTimelineResponse>();
const timeLineReq = ref<JobsTimelineRequest>();

const route = useRoute();
const adapter = new AdapterDashboardService();
const runTasks = ref([]);
const isLoading = ref(false);
req.value = new DashboardParametersRequest({
  FromDate: (() => {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    return date;
  })(),
  ToDate: new Date(new Date().setHours(23, 59, 59, 999)),
  ProjectId: Number(route.params.id),
});

const lastErrorPage = ref(new PageRequest({ Skip: 0, Take: 100 }));

onMounted(async () => {
  console.log("mounted");
  await onUpdate();
});
const ToDate = ref(new Date());
const FromDate = ref(new Date());

const onUpdate = async () => {
  isLoading.value = true;
  const x = await adapter.getDashboardParameters(req.value);
  resp.value = x.Value;

  timeLineReq.value = new JobsTimelineRequest({
    FromDate: req.value.FromDate,
    ToDate: req.value.ToDate,
    ProjectId: req.value.ProjectId,
  });
  const x1 = await adapter.getJobsTimelines(timeLineReq.value);
  timeLineResp.value = x1.Value;
  // emits("update:message", "value");
  const r = await adapter.getJobsLastErrors({
    FromDate: req.value.FromDate,
    ToDate: req.value.ToDate,
    ProjectId: req.value.ProjectId,
    Page: lastErrorPage.value,
  });
  isLoading.value = false;
  lastErrorItems.value = r.Value.Items;
};
const columnTableSetting = ref(["10rem", "20rem", "10rem", "1fr"]);
const router = useRouter();
const statusChangesItems = ref([]);
const lastErrorItems = ref([]);

const handleTaskClick = async (value: {
  jobId: string;
  jobExecuteId: string;
}) => {
  console.log("Task clicked with JobExecuteId:", value.jobExecuteId);
  if (!value.jobId || !value.jobExecuteId) {
    statusChangesItems.value = [];
    return;
  }
  const resp = await adapter.getJobStatusHistory({
    JobId: value.jobId,
    JobExecuteHistoryId: value.jobExecuteId,
    Page: { Skip: 0, Take: 100 },
  });
  statusChangesItems.value = resp.Value.Items;
  // Здесь можно добавить дополнительную логику, например, открыть детали задачи
};
const onScroll = (e) => {
  console.log(e);
};
const items = ref([]);
const onClickAction = (e) => {
  console.log(e);
};
const onClickDetail = (e) => {
  console.log(e);
};
const onClickRemove = (e) => {
  console.log(e);
};

return (_ctx: any,_cache: any) => {
  const _component_TirPmSystemMessage = _resolveComponent("TirPmSystemMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (isLoading.value)
          ? (_openBlock(), _createBlock(Loading, {
              key: 0,
              "overlay-color": "rgba(255, 255, 255, 0.5)"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(TirPmDatepicker), {
            input: { label: 'Дата начала', isSmall: true },
            modelValue: req.value.FromDate,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((req.value.FromDate) = $event)),
              onUpdate
            ],
            type: _unref(DatepickerTypeEnum).DateTime
          }, null, 8, ["modelValue", "type"]),
          _createVNode(_unref(TirPmDatepicker), {
            type: _unref(DatepickerTypeEnum).DateTime,
            input: { label: 'Дата окончания', isSmall: true },
            modelValue: req.value.ToDate,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => ((req.value.ToDate) = $event)),
              onUpdate
            ]
          }, null, 8, ["type", "modelValue"]),
          _createVNode(_unref(TirPmButton), {
            variant: _unref(TirPmButtonVariantEnum).PrimaryState,
            size: _unref(TirPmButtonSizeEnum).Regular,
            onClick: onUpdate
          }, {
            leftSlot: _withCtx(() => [
              _createVNode(_unref(ArrowPathIcon))
            ]),
            default: _withCtx(() => [
              _createTextVNode(" Обновить")
            ]),
            _: 1
          }, 8, ["variant", "size"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(Plashka, { name: "Активных задач сейчас" }, {
              status: _withCtx(() => [
                _createVNode(_unref(ScheduleStatus), {
                  "type-name": _unref(EnumJobStatus).Running,
                  "is-full-size": true
                }, null, 8, ["type-name"])
              ]),
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString(resp.value?.JobsActiveCount), 1)
              ]),
              _: 1
            }),
            _createVNode(Plashka, { name: "Успешных задач за период" }, {
              status: _withCtx(() => [
                _createVNode(_unref(ScheduleStatus), {
                  "type-name": _unref(EnumJobStatus).Success,
                  "is-full-size": true
                }, null, 8, ["type-name"])
              ]),
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString(resp.value?.JobsExecutesSuccessCount), 1)
              ]),
              _: 1
            }),
            _createVNode(Plashka, { name: "Задач с ошибками за период" }, {
              status: _withCtx(() => [
                _createVNode(_unref(ScheduleStatus), {
                  "type-name": _unref(EnumJobStatus).Failed,
                  "is-full-size": true
                }, null, 8, ["type-name"])
              ]),
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString(resp.value?.JobsExecutesFailedCount), 1)
              ]),
              _: 1
            }),
            _createVNode(Plashka, { name: "Статусы за период" }, {
              status: _withCtx(() => []),
              default: _withCtx(() => [
                (resp.value?.JobExecuteStatusStatistic)
                  ? (_openBlock(), _createBlock(DonutChart, {
                      key: 0,
                      data: resp.value.JobExecuteStatusStatistic
                    }, null, 8, ["data"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            (timeLineResp.value?.Jobs)
              ? (_openBlock(), _createBlock(GanttChart, {
                  key: 0,
                  startDate: req.value.FromDate,
                  endDate: req.value.ToDate,
                  tasks: timeLineResp.value.Jobs,
                  onTaskClicked: handleTaskClick
                }, null, 8, ["startDate", "endDate", "tasks"]))
              : _createCommentVNode("", true),
            _createVNode(StatusChanges, { items: statusChangesItems.value }, null, 8, ["items"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(TirPmTable, {
              columns: columnTableSetting.value,
              isBordered: false
            }, {
              topSlot: _withCtx(() => []),
              tableHead: _withCtx(() => [
                _createVNode(TirPmTableTh, {
                  isLeftBorder: false,
                  style: {"min-width":"100px"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Дата создания ")
                  ]),
                  _: 1
                }),
                _createVNode(TirPmTableTh, { isLeftBorder: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Название задачи")
                  ]),
                  _: 1
                }),
                _createVNode(TirPmTableTh, { isLeftBorder: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Статус")
                  ]),
                  _: 1
                }),
                _createVNode(TirPmTableTh, { isLeftBorder: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Сообщение")
                  ]),
                  _: 1
                })
              ]),
              tableBody: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lastErrorItems.value, (data) => {
                  return (_openBlock(), _createBlock(TirPmTableTr, {
                    key: data.Id,
                    columns: columnTableSetting.value,
                    onOnScroll: onScroll
                  }, {
                    default: _withCtx(() => [
                      _createVNode(DashboardRow, {
                        data: data,
                        onClickAction: onClickAction,
                        onClickDetail: onClickDetail,
                        onClickRemove: onClickRemove
                      }, null, 8, ["data"])
                    ]),
                    _: 2
                  }, 1032, ["columns"]))
                }), 128))
              ]),
              emptyDataSlot: _withCtx(() => [
                (!(items.value?.length > 0))
                  ? (_openBlock(), _createBlock(_component_TirPmSystemMessage, {
                      key: 0,
                      style: {"width":"100%"}
                    }, {
                      topDescImage: _withCtx(() => []),
                      mainTitleSlot: _withCtx(() => [
                        _createTextVNode("Нет данных")
                      ]),
                      mainSubtitleSlot: _withCtx(() => [
                        _createTextVNode(" Поменяйте параметры фильтра или перезагрузите ")
                      ]),
                      actionsSlot: _withCtx(() => []),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["columns"])
          ])
        ])
      ])
    ])
  ]))
}
}

})